import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.orders || initialState;

const makeSelectOrdersList = () =>
  createSelector(select, substate => substate.ordersList);

const makeSelectAllOrders = () =>
  createSelector(select, substate => substate.allOrdersReport);

const makeSelectLogs = () => createSelector(select, substate => substate.logs);

const makeSelectBundleAssignment = () =>
  createSelector(select, substate => substate.bundleAssignment);

const makeSelectOrder = () =>
  createSelector(select, substate => substate.order);

const makeSelectCountList = () =>
  createSelector(select, substate => substate.count);

const makeSelectLoading = () =>
  createSelector(select, substate => substate.loading);

const makeSelectError = () =>
  createSelector(select, substate => substate.error);

export default select;
export {
  makeSelectOrdersList,
  makeSelectOrder,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectBundleAssignment,
  makeSelectLogs,
  makeSelectAllOrders,
};
